export const GET_COORDS = "GET_COORDS";
export const GET_POLYON = "GET_POLYON";
export const SAVE_BRANCH_DATA = "SAVE_BRANCH_DATA";
